import { Action } from '@ngrx/store';

export enum DashboardActionTypes {
  INIT_DASHBOARD = '[Cyclops Dashboard] Init Dashboard',
  INIT_SIMULATION = '[Cyclops Dashboard] Init Dashboard Simulation',
  INIT_EMPLOYEE = '[Cyclops Dashboard] Init Employee',
  INIT_ASSETS_TAB = '[Cyclops Dashboard] Init Assets Tab',
  INIT_CALENDAR_TAB = '[Cyclops Dashboard] Init Calendar Tab',
  INIT_SECURITY_ADVANCED = '[Cyclops Dashboard] Init Security Advanced',
  INIT_MEDIA_WALL_TAB = '[Cyclops Dashboard] Init Media Wall Tab',
  INIT_MANAGE_USER_TAB = '[Cyclops Dashboard] Init Manage User Tab',
  INIT_SETTINGS_TAB = '[Cyclops Dashboard] Init Settings Tab',
  INIT_SECURITY_GUARD_TAB = '[Cyclops Dashboard] Init Security Guard Tab',
  INIT_REPORTS_TAB = '[Cyclops Dashboard] Init Reports Tab',
  INIT_ANALYTICS_TAB = '[Cyclops Dashboard] Init Analytics Tab',
  INIT_VISITOR_GATE_ENTRY_TAB = '[Cyclops Dashboard] Init Visitor Gate Entry',
  INIT_INCIDENT_MANUAL_EVENT_TAB = '[Cyclops Dashboard] Init Incident Manual Event',
  INIT_USER_PROFILE_SETTING = '[Cyclops Dashboard] Init User Profile Setting',
  INIT_PRE_VERIFIED_TAB = '[Cyclops Dashboard] Init Pre Verified Flow',
  INIT_AUMYE_COMMUNITY = '[Cyclops Dashboard] Init Aumye Community Flow',
  GET_USER_LIST = '[Cyclops Dashboard] Get User List',
  GET_USER_LIST_SUCCESS = '[Cyclops Dashboard] Get User List Success',
  GET_USER_LIST_FAILURE = '[Cyclops Dashboard] Get User List Failure',
  SET_CONTEXT_DATA = '[Cyclops Dashboard] Set Context Data',
  LOAD_ALL_PROPERTY = '[Cyclops Dashboard Load All Property',
  LOAD_ALL_PROPERTY_SUCCESS = '[Cyclops Dashboard Load All Property Success',
  LOAD_ALL_PROPERTY_FAILURE = '[Cyclops Dashboard Load All Property Failure',
  LOAD_ALL_ASSETS = '[Cyclops Dashboard Load All Assets',
  LOAD_ALL_ASSETS_SUCCESS = '[Cyclops Dashboard Load All Assets Success',
  LOAD_ALL_ASSETS_FAILURE = '[Cyclops Dashboard Load All Assets Failure',
  GET_VISITOR_TAB_DATA = '[Cyclops Dashboard] Get Visitor Tab Data',
  GET_VISITOR_TAB_DATA_SUCCESS = '[Cyclops Dashboard] Get Visitor Tab Data Success',
  GET_VISITOR_TAB_DATA_FAILURE = '[Cyclops Dashboard] Get Visitor Tab Data Failure',

  GET_DASHBOARD_DATA = '[Cyclops Dashboard] Get Dashboard Data',
  GET_DASHBOARD_DATA_SUCCESS = '[Cyclops Dashboard] Get Dashboard Data Success',
  GET_DASHBOARD_DATA_FAILURE = '[Cyclops Dashboard] Get Dashboard Data Failure',

  GET_RANGED_VISITOR_DATA = '[Cyclops Dashboard] Get Ranged Visitor Data',
  GET_RANGED_VISITOR_DATA_SUCCESS = '[Cyclops Dashboard] Get Ranged Visitor Data Success',
  GET_RANGED_VISITOR_DATA_FAILURE = '[Cyclops Dashboard] Get Ranged Visitor Data Failure',

  GET_RANGED_REQUEST_DATA = '[Cyclops Dashboard] Get Ranged Requests Data',
  GET_RANGED_REQUEST_DATA_SUCCESS = '[Cyclops Dashboard] Get Ranged Requests Data Success',
  GET_RANGED_REQUEST_DATA_FAILURE = '[Cyclops Dashboard] Get Ranged Requests Data Failure',

  GET_RANGED_INCIDENT_DATA = '[Cyclops Dashboard] Get Ranged Incident Data',
  GET_RANGED_INCIDENT_DATA_SUCCESS = '[Cyclops Dashboard] Get Ranged Incident Data Success',
  GET_RANGED_INCIDENT_DATA_FAILURE = '[Cyclops Dashboard] Get Ranged Incident Data Failure',

  CHECK_EXISTING_VISITOR = '[Cyclops Dashboard] Check Existing Visitor',
  CHECK_EXISTING_VISITOR_SUCCESS = '[Cyclops Dashboard] Check Existing Visitor Success',
  CHECK_EXISTING_VISITOR_FAILURE = '[Cyclops Dashboard] Check Existing Visitor Failure',

  GET_INCIDENT_TAB_DATA = '[Cyclops Dashboard] Get Incident Tab Data',
  GET_INCIDENT_TAB_DATA_SUCCESS = '[Cyclops Dashboard] Get Incident Tab Data Success',
  GET_INCIDENT_TAB_DATA_FAILURE = '[Cyclops Dashboard] Get Incident Tab Data Failure',
  USER_LOGOUT = '[Cyclops Dashboard] User Logout',
  REDIRECTING_TO_LOGIN = '[Cyclops Dashboard]  Redirecting To Login',
  VISITOR_NOTIFY_HOST = '[Cyclops Dashboard] Visitor Notify Host',
  VISITOR_NOTIFY_HOST_SUCCESS = '[Cyclops Dashboard] Visitor Notify Host Success',
  VISITOR_NOTIFY_HOST_FAILURE = '[Cyclops Dashboard] Visitor Notify Host Failure',
  HOST_STATUS = '[Cyclops Dashboard] Host Status',
  HOST_STATUS_SUCCESS = '[Cyclops Dashboard] Host Status Success',
  HOST_STATUS_FAILURE = '[Cyclops Dashboard] Host Status Failure',
  CLEAR_VISITOR_ENTRY = '[Cyclops Dashboard] Clear Visitor Entry',
  CLEAR_VISITOR_ENTRY_SUCCESS = '[Cyclops Dashboard] Clear Visitor Entry Success',
  CLEAR_VISITOR_ENTRY_FAILURE = '[Cyclops Dashboard] Clear Visitor Entry Failure',
  CREATE_MANUAL_INCIDENT = '[Cyclops Dashboard] Create Manual Incident',
  CREATE_MANUAL_INCIDENT_SUCCESS = '[Cyclops Dashboard] Create Manual Incident Success',
  CREATE_MANUAL_INCIDENT_FAILURE = '[Cyclops Dashboard] Create Manual Incident Failure',
  VERIFY_INCIDENT = '[Cyclops Dashboard] Verify Incident',
  VERIFY_INCIDENT_SUCCESS = '[Cyclops Dashboard] Verify Incident Success',
  VERIFY_INCIDENT_FAILURE = '[Cyclops Dashboard] Verify Incident Failure',
  SNOOZE_INCIDENT = '[Cyclops Dashboard] Snooze Incident',
  SNOOZE_INCIDENT_SUCCESS = '[Cyclops Dashboard] Snooze Incident Success',
  SNOOZE_INCIDENT_FAILURE = '[Cyclops Dashboard] Snooze Incident Failure',
  UPDATE_VISITOR_LIST = '[Cyclops Dashboard] Update Visitor List',
  UPDATE_VISITOR_LIST_SUCCESS = '[Cyclops Dashboard] Update Visitor List Success',
  UPDATE_VISITOR_LIST_FAILURE = '[Cyclops Dashboard] Update Visitor List Failure',
  UPDATE_INCIDENT_LIST = '[Cyclops Dashboard] Update Incident List',
  UPDATE_INCIDENT_LIST_SUCCESS = '[Cyclops Dashboard] Update Incident List Success',
  UPDATE_INCIDENT_LIST_FAILURE = '[Cyclops Dashboard] Update Incident List Failure',
  GET_NUMBER_PLATES_LIST = '[Cyclops Dashboard] Get Number PLate List',
  GET_NUMBER_PLATES_LIST_SUCCESS = '[Cyclops Dashboard] Get Number PLate List Success',
  GET_NUMBER_PLATES_LIST_FAILURE = '[Cyclops Dashboard] Get Number PLate List Failure',
  GET_FACE_TIMELINE = '[Cyclops Dashboard] Get Face Timeline',
  GET_FACE_TIMELINE_SUCCESS = '[Cyclops Dashboard] Get Face Timeline Success',
  GET_FACE_TIMELINE_FAILURE = '[Cyclops Dashboard] Get Face Timeline Failure',
  GET_INCIDENT_EVIDENCE = '[Cyclops Dashboard] Get Incident Evidence',
  GET_INCIDENT_EVIDENCE_SUCCESS = '[Cyclops Dashboard] Get Incident Evidence Success',
  GET_INCIDENT_EVIDENCE_FAILURE = '[Cyclops Dashboard] Get Incident Evidence Failure',
  LODGE_USER_COMPLAINT = '[Cyclops Dashboard] Lodge User Complain',
  LODGE_USER_COMPLAINT_SUCCESS = '[Cyclops Dashboard] Lodge User Complain Success',
  LODGE_USER_COMPLAINT_FAILURE = '[Cyclops Dashboard] Lodge User Complain Failure',
  SEND_BULK_INVITE = '[Cyclops Dashboard] Send Bulk Invite',
  SEND_BULK_INVITE_SUCCESS = '[Cyclops Dashboard] Send Bulk Invite Success',
  SEND_BULK_INVITE_FAILURE = '[Cyclops Dashboard] Send Bulk Invite Failure',
  CREATE_NOTICE_BOARD_POST = '[Cyclops Dashboard] Create Notice Board Post',
  CREATE_NOTICE_BOARD_POST_SUCCESS = '[Cyclops Dashboard] Create Notice Board Post Success',
  CREATE_NOTICE_BOARD_POST_FAILURE = '[Cyclops Dashboard] Create Notice Board Post Failure',
  GET_NOTICE_BOARD_POSTS = '[Cyclops Dashboard] Get Notice Board Posts',
  GET_NOTICE_BOARD_POSTS_SUCCESS = '[Cyclops Dashboard] Get Notice Board Posts Success',
  GET_NOTICE_BOARD_POSTS_FAILURE = '[Cyclops Dashboard] Get Notice Board Posts Failure',
  POST_USER_COMMENT = '[Cyclops Dashboard] Post User Comment',
  POST_USER_COMMENT_SUCCESS = '[Cyclops Dashboard] Post User Comment Success',
  POST_USER_COMMENT_FAILURE = '[Cyclops Dashboard] Post User Comment Failure',
  DELETE_USER_PERMANENTLY = '[Cyclops Dashboard] Delete User Permanently Post',
  DELETE_USER_PERMANENTLY_SUCCESS = '[Cyclops Dashboard] Delete User Permanently Post Success',
  DELETE_USER_PERMANENTLY_FAILURE = '[Cyclops Dashboard] Delete User Permanently Post Failure',

  UPDATE_FLAGGED_POST = '[Cyclops Dashboard] Update Flagged',
  UPDATE_FLAGGED_POST_SUCCESS = '[Cyclops Dashboard] Update Flagged Success',
  UPDATE_FLAGGED_POST_FAILURE = '[Cyclops Dashboard] Update Flagged Failure',
  ACCEPT_OR_REJECT_POST = '[Cyclops Dashboard] Accept Or Reject Post',
  ACCEPT_OR_REJECT_POST_SUCCESS = '[Cyclops Dashboard] Accept Or Reject Post Success',
  ACCEPT_OR_REJECT_POST_FAILURE = '[Cyclops Dashboard] Accept Or Reject Post Failure',
  REPORT_POST = '[Cyclops Dashboard] Report Post',
  REPORT_POST_SUCCESS = '[Cyclops Dashboard] Report Post Success',
  REPORT_POST_FAILURE = '[Cyclops Dashboard] Report Post Failure',
  POST_USER_LIKE = '[Cyclops Dashboard] Post User Like',
  POST_USER_LIKE_SUCCESS = '[Cyclops Dashboard] Post User Like Success',
  POST_USER_LIKE_FAILURE = '[Cyclops Dashboard] Post User Like Failure',
  ADD_PRE_APPROVED_VISITOR = '[Cyclops Dashboard] Add pre Approved Visitor',
  ADD_PRE_APPROVED_VISITOR_SUCCESS = '[Cyclops Dashboard] Add pre Approved Visitor Success',
  ADD_PRE_APPROVED_VISITOR_FAILURE = '[Cyclops Dashboard] Add pre Approved Visitor Failure',
  RAPID_SCHEDULE_VISITOR = '[Cyclops Dashboard] Rapid Schedule Visitor',
  RAPID_SCHEDULE_VISITOR_SUCCESS = '[Cyclops Dashboard] Rapid Schedule Visitor Success',
  RAPID_SCHEDULE_VISITOR_FAILURE = '[Cyclops Dashboard] Rapid Schedule Visitor Failure',
  GET_USER_EVENTS_LIST = '[Cyclops Dashboard] Get User Events List',
  GET_USER_EVENTS_LIST_SUCCESS = '[Cyclops Dashboard] Get User Events List Success',
  GET_USER_EVENTS_LIST_FAILURE = '[Cyclops Dashboard] Get User Events List Failure',
  CREATE_USER_POLL = '[Cyclops Dashboard] Create User Poll',
  CREATE_USER_POLL_SUCCESS = '[Cyclops Dashboard] Create User Poll Success',
  CREATE_USER_POLL_FAILURE = '[Cyclops Dashboard] Create User Poll Failure',
  MANAGE_USER_POLL = '[Cyclops Dashboard] Manage  User Poll',
  MANAGE_USER_POLL_SUCCESS = '[Cyclops Dashboard] Manage  User Poll Success',
  MANAGE_USER_POLL_FAILURE = '[Cyclops Dashboard] Manage  User Poll Failure',
  GET_USER_POLL_LIST = '[Cyclops Dashboard] Get User Polls List',
  GET_USER_POLL_LIST_SUCCESS = '[Cyclops Dashboard] Get User Polls List Success',
  GET_USER_POLL_LIST_FAILURE = '[Cyclops Dashboard] Get User Polls List Failure',
  SUBMIT_POLL_RESPONSE = '[Cyclops Dashboard] Submit Poll Response',
  SUBMIT_POLL_RESPONSE_SUCCESS = '[Cyclops Dashboard] Submit Poll Response Success',
  SUBMIT_POLL_RESPONSE_FAILURE = '[Cyclops Dashboard] Submit Poll Response Failure',
  UPDATE_VISITOR_DETAILS = '[Cyclops Dashboard] Update Visitor Details',
  UPDATE_VISITOR_DETAILS_SUCCESS = '[Cyclops Dashboard] Update Visitor Details Success',
  UPDATE_VISITOR_DETAILS_FAILURE = '[Cyclops Dashboard] Update Visitor Details Failure',
  PRE_APPROVED_VISITOR_CHECKOUT = '[Cyclops Dashboard] Pre Approved Visitor Checkout',
  PRE_APPROVED_VISITOR_CHECKOUT_SUCCESS = '[Cyclops Dashboard] Pre Approved Visitor Checkout Success',
  PRE_APPROVED_VISITOR_CHECKOUT_FAILURE = '[Cyclops Dashboard] Pre Approved Visitor Checkout Failure',

  UPDATE_VISITOR_ID_DETAIL = '[Cyclops Dashboard] Update Visitor Id Detail',
  UPDATE_VISITOR_ID_DETAIL_SUCCESS = '[Cyclops Dashboard] Update Visitor Id Detail Success',
  UPDATE_VISITOR_ID_DETAIL_FAILURE = '[Cyclops Dashboard] Update Visitor Id Detail Failure',

  SEND_REPORTS_DATA = '[Cyclops Dashboard] Send Reports Data',
  SEND_REPORTS_DATA_SUCCESS = '[Cyclops Dashboard] Send Reports Data Success',
  SEND_REPORTS_DATA_FAILURE = '[Cyclops Dashboard] Send Reports Data Failure',

  REQUEST_SOS = '[Cyclops Dashboard] Request SOS',
  REQUEST_SOS_SUCCESS = '[Cyclops Dashboard] Request SOS Success',
  REQUEST_SOS_FAILED = '[Cyclops Dashboard] Request SOS Failed',
  RESPOND_SOS = '[Cyclops Dashboard] Respond SOS',
  STORE_LOCATION = '[Cyclops Dashboard] Store User Location',

  UPDATE_ASSETS_DATA = '[Cyclops Dashboard] Update Assets Data',
  RESET_STATE = '[Cyclops Dashboard] Reset State',

  FETCH_EMPLOYEES = '[Cyclops Dashboard] Fetch Employees',
  FETCH_EMPLOYEES_SUCCESS = '[Cyclops Dashboard] Fetch Employees Success',
  FETCH_EMPLOYEES_FAILURE = '[Cyclops Dashboard] Fetch Employees Failure',

  UPDATE_EMPLOYEES = '[Cyclops Dashboard] Update Employees',
  UPDATE_EMPLOYEES_SUCCESS = '[Cyclops Dashboard] Update Employees Success',
  UPDATE_EMPLOYEES_FAILURE = '[Cyclops Dashboard] Update Employees Failure',

  LOG_EMPLOYEE_ATTENDANCE = '[Cyclops Dashboard] Log Employee Attendance',
  LOG_EMPLOYEE_ATTENDANCE_SUCCESS = '[Cyclops Dashboard] Log Employee Attendance Success',
  LOG_EMPLOYEE_ATTENDANCE_FAILURE = '[Cyclops Dashboard] Log Employee Attendance Failure',

  SEND_QR_WHATSAPP = '[Cyclops Dashboard] Send QR Whatsapp',
  SEND_QR_WHATSAPP_SUCCESS = '[Cyclops Dashboard] Send QR Whatsapp Success',
  SEND_QR_WHATSAPP_FAILURE = '[Cyclops Dashboard] Send QR Whatsapp Failure',

  SEARCH_NUMBER = '[Cyclops Dashboard] Search Number',
  SEARCH_NUMBER_SUCCESS = '[Cyclops Dashboard] Search Number Success',
  SEARCH_NUMBER_FAILURE = '[Cyclops Dashboard] Search Number Failure',

  SAVE_ORG_SETTINGS = '[Cyclops Dashboard] Save Org Settings',
  SAVE_ORG_SETTINGS_SUCCESS = '[Cyclops Dashboard] Save Org Settings Success',
  SAVE_ORG_SETTINGS_FAILURE = '[Cyclops Dashboard] Save Org Settings Failure',

  GET_ORG_SETTINGS = '[Cyclops Dashboard] Get Org Settings',
  GET_ORG_SETTINGS_SUCCESS = '[Cyclops Dashboard] Get Org Settings Success',
  GET_ORG_SETTINGS_FAILURE = '[Cyclops Dashboard] Get Org Settings Failure',

  MANAGE_VISITOR_PASS = '[Cyclops Dashboard] Manage Visitor Pass',
  MANAGE_VISITOR_PASS_SUCCESS = '[Cyclops Dashboard] Manage Visitor Pass Success',
  MANAGE_VISITOR_PASS_FAILURE = '[Cyclops Dashboard] Manage Visitor Pass Failure',

  SAVE_USER_INVENTORY = '[Cyclops Dashboard] Save User Inventory',
  SAVE_USER_INVENTORY_SUCCESS = '[Cyclops Dashboard] Save User Inventory Success',
  SAVE_USER_INVENTORY_FAILURE = '[Cyclops Dashboard] Save User Inventory Failure',

  GET_USER_INVENTORY = '[Cyclops Dashboard] Get User Inventory',
  GET_USER_INVENTORY_SUCCESS = '[Cyclops Dashboard] Get User Inventory Success',
  GET_USER_INVENTORY_FAILURE = '[Cyclops Dashboard] Get User Inventory Failure',

  GET_COMPLAINTS_TICKET = '[Cyclops Dashboard] Get Complaints Ticket',
  GET_COMPLAINTS_TICKET_SUCCESS = '[Cyclops Dashboard] Get Complaints Ticket Success',
  GET_COMPLAINTS_TICKET_FAILURE = '[Cyclops Dashboard] Get Complaints Ticket Failure',

  GET_CLAIM_TICKET = '[Cyclops Dashboard] Get CLAIM Ticket',
  GET_CLAIM_TICKET_SUCCESS = '[Cyclops Dashboard] Get CLAIM Ticket Success',
  GET_CLAIM_TICKET_FAILURE = '[Cyclops Dashboard] Get Complaints Ticket Failure',

  GET_REQUESTS_TICKET = '[Cyclops Dashboard] Get REQUESTS Ticket',
  GET_REQUESTS_TICKET_SUCCESS = '[Cyclops Dashboard] Get REQUESTS Ticket Success',
  GET_REQUESTS_TICKET_FAILURE = '[Cyclops Dashboard] Get REQUESTS Ticket Failure',

  CLUSTER_PREAPPROVED_VISITOR = '[Cyclops Dashboard] Cluster Preapproved Visitor',
  CLUSTER_PREAPPROVED_VISITOR_SUCCESS = '[Cyclops Dashboard] Cluster Preapproved Visitor Success',
  CLUSTER_PREAPPROVED_VISITOR_FAILURE = '[Cyclops Dashboard] Cluster Preapproved Visitor Failure',

  SAVE_APP_TOKEN = '[Cyclops Dashboard] Save App Token',
  SAVE_APP_TOKEN_SUCCESS = '[Cyclops Dashboard] Save App Token Success',
  SAVE_APP_TOKEN_FAILURE = '[Cyclops Dashboard] Save App Token Failure',

  REMOVE_APP_TOKEN = '[Cyclops Dashboard] Remove App Token',
  REMOVE_APP_TOKEN_SUCCESS = '[Cyclops Dashboard] Remove App Token Success',
  REMOVE_APP_TOKEN_FAILURE = '[Cyclops Dashboard] Remove App Token Failure',

  ADD_USER_EMPLOYEES = '[Cyclops Dashboard] Add User To Employee',
  ADD_USER_EMPLOYEES_SUCCESS = '[Cyclops Dashboard] Add User To Employee Success',
  ADD_USER_EMPLOYEES_FAILURE = '[Cyclops Dashboard] Add User To Employee Failure',

  SAVE_INCIDENT_DATA = '[Cyclops Dashboard] Save Incident Data',
  SAVE_SOS_DATA = '[Cyclops Dashboard] Save SOS Data',
  SAVE_RISK_DATA = '[Cyclops Dashboard] Save Risk Data',
  SAVE_PROPERTY_DATA = '[Cyclops Dashboard] Save Property Data',
  SAVE_ASSET_DATA = '[Cyclops Dashboard] Save Asset Data',
  SAVE_USER_DATA = '[Cyclops Dashboard] Save User Data',
  SAVE_COMPLAIN_DATA = '[Cyclops Dashboard] Save Complain Data',
  UPDATE_COMPLAIN_DATA = '[Cyclops Dashboard] Update Complain Data',
  UPDATE_INCIDENT_DATA = '[Cyclops Dashboard] Update Incident Data',
  UPDATE_SOS_DATA = '[Cyclops Dashboard] Update SOS Data',

  // Complaint Actions
  ADD_NEW_COMPLAINT = '[Cyclops Dashboard] Add New Complaint',
  ADD_NEW_COMPLAINT_SUCCESS = '[Cyclops Dashboard] Add New Complaint Success',
  ADD_NEW_COMPLAINT_FAILURE = '[Cyclops Dashboard] Add New Complaint Failure',
  UPDATE_COMPLAINT_BY_ID = '[Cyclops Dashboard] Update Complaint Data By Id',
  UPDATE_COMPLAINT_BY_ID_SUCCESS = '[Cyclops Dashboard] Update Complaint Data By Id Success',
  UPDATE_COMPLAINT_BY_ID_FAILURE = '[Cyclops Dashboard] Update Complaint Data By Id Failure',

  // Claim Actions
  ADD_NEW_CLAIM = '[Cyclops Dashboard] Add New Claim',
  ADD_NEW_CLAIM_SUCCESS = '[Cyclops Dashboard] Add New Claim Success',
  ADD_NEW_CLAIM_FAILURE = '[Cyclops Dashboard] Add New Claim Failure',
  UPDATE_CLAIM_BY_ID = '[Cyclops Dashboard] Update Claim Data By Id',
  UPDATE_CLAIM_BY_ID_SUCCESS = '[Cyclops Dashboard] Update Claim Data By Id Success',
  UPDATE_CLAIM_BY_ID_FAILURE = '[Cyclops Dashboard] Update Claim Data By Id Failure',

  // Request Actions
  ADD_NEW_REQUEST = '[Cyclops Dashboard] Add New Request',
  ADD_NEW_REQUEST_SUCCESS = '[Cyclops Dashboard] Add New Request Success',
  ADD_NEW_REQUEST_FAILURE = '[Cyclops Dashboard] Add New Request Failure',
  UPDATE_REQUEST_BY_ID = '[Cyclops Dashboard] Update Request Data By Id',
  UPDATE_REQUEST_BY_ID_SUCCESS = '[Cyclops Dashboard] Update Request Data By Id Success',
  UPDATE_REQUEST_BY_ID_FAILURE = '[Cyclops Dashboard] Update Request Data By Id Failure',

  // Incident Actions
  ADD_NEW_INCIDENT = '[Cyclops Dashboard] Add New Incident',
  ADD_NEW_INCIDENT_SUCCESS = '[Cyclops Dashboard] Add New Incident Success',
  ADD_NEW_INCIDENT_FAILURE = '[Cyclops Dashboard] Add New Incident Failure',
  UPDATE_INCIDENT_BY_ID = '[Cyclops Dashboard] Update Incident Data By Id',
  UPDATE_INCIDENT_BY_ID_SUCCESS = '[Cyclops Dashboard] Update Incident Data By Id Success',
  UPDATE_INCIDENT_BY_ID_FAILURE = '[Cyclops Dashboard] Update Incident Data By Id Failure',

  // Visitor Actions
  ADD_NEW_VISITOR = '[Cyclops Dashboard] Add New Visitor',
  ADD_NEW_VISITOR_SUCCESS = '[Cyclops Dashboard] Add New Visitor Success',
  ADD_NEW_VISITOR_FAILURE = '[Cyclops Dashboard] Add New Visitor Failure',
  UPDATE_VISITOR_BY_ID = '[Cyclops Dashboard] Update Visitor Data By Id',
  UPDATE_VISITOR_BY_ID_SUCCESS = '[Cyclops Dashboard] Update Visitor Data By Id Success',
  UPDATE_VISITOR_BY_ID_FAILURE = '[Cyclops Dashboard] Update Visitor Data By Id Failure',

  //Employee Actions
  UPDATE_EMPLOYEE_ATTENDANCE_BY_ID = '[Cyclops Dashboard] Update Employee Attendance By Id',
  UPDATE_EMPLOYEE_ATTENDANCE_BY_ID_SUCCESS = '[Cyclops Dashboard] Update Employee Attendance By Id Success',
  UPDATE_EMPLOYEE_ATTENDANCE_BY_ID_FAILURE = '[Cyclops Dashboard] Update Employee Attendance By Id Failure',

  //User Actions
  ADD_NEW_USER = '[Cyclops Dashboard] Add New User',
  ADD_NEW_USER_SUCCESS = '[Cyclops Dashboard] Add New User Success',
  ADD_NEW_USER_FAILURE = '[Cyclops Dashboard] Add New User Failure',
  UPDATE_USER_BY_ID = '[Cyclops Dashboard] Update User Data By Id',
  UPDATE_USER_BY_ID_SUCCESS = '[Cyclops Dashboard] Update User Data By Id Success',
  UPDATE_USER_BY_ID_FAILURE = '[Cyclops Dashboard] Update User Data By Id Failure',

  REMOVE_INCIDENT_BY_ID = '[Cyclops Dashboard] Remove Incident By Id',
  REMOVE_INCIDENT_BY_ID_SUCCESS = '[Cyclops Dashboard] Remove Incident By Id Success',
  REMOVE_INCIDENT_BY_ID_FAILURE = '[Cyclops Dashboard] Remove Incident By Id Failure',

  REMOVE_CLAIMS_BY_ID = '[Cyclops Dashboard] Remove CLAIMS By Id',
  REMOVE_CLAIMS_BY_ID_SUCCESS = '[Cyclops Dashboard] Remove CLAIMS By Id Success',
  REMOVE_CLAIMS_BY_ID_FAILURE = '[Cyclops Dashboard] Remove CLAIMS By Id Failure',

  REMOVE_SERVICE_BY_ID = '[Cyclops Dashboard] Remove SERVICE By Id',
  REMOVE_SERVICE_BY_ID_SUCCESS = '[Cyclops Dashboard] Remove SERVICE By Id Success',
  REMOVE_SERVICE_BY_ID_FAILURE = '[Cyclops Dashboard] Remove SERVICE By Id Failure',

  REMOVE_COMPLAINTS_BY_ID = '[Cyclops Dashboard] Remove COMPLAINTS By Id',
  REMOVE_COMPLAINTS_BY_ID_SUCCESS = '[Cyclops Dashboard] Remove COMPLAINTS By Id Success',
  REMOVE_COMPLAINTS_BY_ID_FAILURE = '[Cyclops Dashboard] Remove COMPLAINTS By Id Failure',

  ADD_NEW_NOTIFICATION = '[Cyclops Dashboard] Add New Notification',
  MARK_READ_NOTIFICATION = '[Cyclops Dashboard] Mark Read Notification',
  GET_SAVED_NOTIFICATION = '[Cyclops Dashboard] Get Saved Notification',
}
export class ResetState implements Action {
  readonly type = DashboardActionTypes.RESET_STATE;
  constructor(public payload: any) {}
}
export class SaveIncidentData implements Action {
  readonly type = DashboardActionTypes.SAVE_INCIDENT_DATA;
  constructor(public payload: any) {}
}
export class UpdateIncidentData implements Action {
  readonly type = DashboardActionTypes.UPDATE_INCIDENT_DATA;
  constructor(public payload: any) {}
}
export class UpdateSOSData implements Action {
  readonly type = DashboardActionTypes.UPDATE_SOS_DATA;
  constructor(public payload: any) {}
}
export class SavePropertyData implements Action {
  readonly type = DashboardActionTypes.SAVE_PROPERTY_DATA;
  constructor(public payload: any) {}
}
export class SaveAssetData implements Action {
  readonly type = DashboardActionTypes.SAVE_ASSET_DATA;
  constructor(public payload: any) {}
}
export class SaveUserData implements Action {
  readonly type = DashboardActionTypes.SAVE_USER_DATA;
  constructor(public payload: any) {}
}
export class SaveComplainData implements Action {
  readonly type = DashboardActionTypes.SAVE_COMPLAIN_DATA;
  constructor(public payload: any) {}
}
export class UpdateComplainData implements Action {
  readonly type = DashboardActionTypes.UPDATE_COMPLAIN_DATA;
  constructor(public payload: any) {}
}

export class SaveSOSData implements Action {
  readonly type = DashboardActionTypes.SAVE_SOS_DATA;
  constructor(public payload: any) {}
}
export class SaveRiskData implements Action {
  readonly type = DashboardActionTypes.SAVE_RISK_DATA;
  constructor(public payload: any) {}
}
export class SaveAppToken implements Action {
  readonly type = DashboardActionTypes.SAVE_APP_TOKEN;
  constructor(public payload: any) {}
}
export class SaveAppTokenFailed implements Action {
  readonly type = DashboardActionTypes.SAVE_APP_TOKEN_FAILURE;
  constructor(public payload: any) {}
}
export class SaveAppTokenSuccess implements Action {
  readonly type = DashboardActionTypes.SAVE_APP_TOKEN_SUCCESS;
  constructor(public payload: any) {}
}
export class RemoveAppToken implements Action {
  readonly type = DashboardActionTypes.REMOVE_APP_TOKEN;
  constructor(public payload: any) {}
}
export class RemoveAppTokenFailed implements Action {
  readonly type = DashboardActionTypes.REMOVE_APP_TOKEN_FAILURE;
  constructor(public payload: any) {}
}
export class RemoveAppTokenSuccess implements Action {
  readonly type = DashboardActionTypes.REMOVE_APP_TOKEN_SUCCESS;
  constructor(public payload: any) {}
}
export class InitDashboard implements Action {
  readonly type = DashboardActionTypes.INIT_DASHBOARD;
  constructor(public payload: any) {}
}
export class InitDashboardSim implements Action {
  readonly type = DashboardActionTypes.INIT_SIMULATION;
  constructor(public payload: any) {}
}
export class InitEmplopyee implements Action {
  readonly type = DashboardActionTypes.INIT_EMPLOYEE;
  constructor(public payload: any) {}
}
export class InitAssetsTab implements Action {
  readonly type = DashboardActionTypes.INIT_ASSETS_TAB;
  constructor(public payload: any) {}
}
export class InitCalendarTab implements Action {
  readonly type = DashboardActionTypes.INIT_CALENDAR_TAB;
  constructor(public payload: any) {}
}
export class InitMediaWallTab implements Action {
  readonly type = DashboardActionTypes.INIT_MEDIA_WALL_TAB;
  constructor(public payload: any) {}
}
export class InitSecurityGuardTab implements Action {
  readonly type = DashboardActionTypes.INIT_SECURITY_GUARD_TAB;
  constructor(public payload: any) {}
}
export class InitManageUserTab implements Action {
  readonly type = DashboardActionTypes.INIT_MANAGE_USER_TAB;
  constructor(public payload: any) {}
}
export class InitSecurityAdvanced implements Action {
  readonly type = DashboardActionTypes.INIT_SECURITY_ADVANCED;
  constructor(public payload: any) {}
}
export class InitSettingsTab implements Action {
  readonly type = DashboardActionTypes.INIT_SETTINGS_TAB;
  constructor(public payload: any) {}
}
export class InitReportsTab implements Action {
  readonly type = DashboardActionTypes.INIT_REPORTS_TAB;
  constructor(public payload: any) {}
}
export class InitAnalyticsTab implements Action {
  readonly type = DashboardActionTypes.INIT_ANALYTICS_TAB;
  constructor(public payload: any) {}
}
export class InitVisitorGateEntry implements Action {
  readonly type = DashboardActionTypes.INIT_VISITOR_GATE_ENTRY_TAB;
  constructor(public payload: any) {}
}
export class InitIncidentManualEvent implements Action {
  readonly type = DashboardActionTypes.INIT_INCIDENT_MANUAL_EVENT_TAB;
  constructor(public payload: any) {}
}
export class SetContextData implements Action {
  readonly type = DashboardActionTypes.SET_CONTEXT_DATA;
  constructor(public payload: any) {}
}
export class GetUserList implements Action {
  readonly type = DashboardActionTypes.GET_USER_LIST;
  constructor(public payload: any) {}
}
export class GetUserListSuccess implements Action {
  readonly type = DashboardActionTypes.GET_USER_LIST_SUCCESS;
  constructor(public payload: any) {}
}
export class GetUserListFailure implements Action {
  readonly type = DashboardActionTypes.GET_USER_LIST_FAILURE;
  constructor(public payload: any) {}
}
export class GetComplaintsTickets implements Action {
  readonly type = DashboardActionTypes.GET_COMPLAINTS_TICKET;
  constructor(public payload: any) {}
}
export class GetComplaintsTicketsSuccess implements Action {
  readonly type = DashboardActionTypes.GET_COMPLAINTS_TICKET_SUCCESS;
  constructor(public payload: any) {}
}
export class GetComplaintsTicketsFailure implements Action {
  readonly type = DashboardActionTypes.GET_COMPLAINTS_TICKET_FAILURE;
  constructor(public payload: any) {}
}
export class GetClaimTickets implements Action {
  readonly type = DashboardActionTypes.GET_CLAIM_TICKET;
  constructor(public payload: any) {}
}
export class GetClaimTicketsSuccess implements Action {
  readonly type = DashboardActionTypes.GET_CLAIM_TICKET_SUCCESS;
  constructor(public payload: any) {}
}
export class GetClaimTicketsFailed implements Action {
  readonly type = DashboardActionTypes.GET_CLAIM_TICKET_FAILURE;
  constructor(public payload: any) {}
}
export class GetRequestsTickets implements Action {
  readonly type = DashboardActionTypes.GET_REQUESTS_TICKET;
  constructor(public payload: any) {}
}
export class GetRequestsTicketsSuccess implements Action {
  readonly type = DashboardActionTypes.GET_REQUESTS_TICKET_SUCCESS;
  constructor(public payload: any) {}
}
export class GetRequestsTicketsFailed implements Action {
  readonly type = DashboardActionTypes.GET_REQUESTS_TICKET_FAILURE;
  constructor(public payload: any) {}
}
export class ClusterPreApprovedVisitor implements Action {
  readonly type = DashboardActionTypes.CLUSTER_PREAPPROVED_VISITOR;
  constructor(public payload: any) {}
}
export class ClusterPreApprovedVisitorSuccess implements Action {
  readonly type = DashboardActionTypes.CLUSTER_PREAPPROVED_VISITOR_SUCCESS;
  constructor(public payload: any) {}
}
export class ClusterPreApprovedVisitorFailure implements Action {
  readonly type = DashboardActionTypes.CLUSTER_PREAPPROVED_VISITOR_FAILURE;
  constructor(public payload: any) {}
}
export class LoadAllProperty implements Action {
  readonly type = DashboardActionTypes.LOAD_ALL_PROPERTY;
  constructor(public payload: any) {}
}
export class LoadAllPropertySuccess implements Action {
  readonly type = DashboardActionTypes.LOAD_ALL_PROPERTY_SUCCESS;
  constructor(public payload: any) {}
}
export class LoadAllPropertyFailure implements Action {
  readonly type = DashboardActionTypes.LOAD_ALL_PROPERTY_FAILURE;
  constructor(public payload: any) {}
}
export class LoadAllAssets implements Action {
  readonly type = DashboardActionTypes.LOAD_ALL_ASSETS;
  constructor(public payload: any) {}
}
export class LoadAllAssetsSuccess implements Action {
  readonly type = DashboardActionTypes.LOAD_ALL_ASSETS_SUCCESS;
  constructor(public payload: any) {}
}
export class LoadAllAssetsFailure implements Action {
  readonly type = DashboardActionTypes.LOAD_ALL_ASSETS_FAILURE;
  constructor(public payload: any) {}
}
export class GetRangedRequestsData implements Action {
  readonly type = DashboardActionTypes.GET_RANGED_REQUEST_DATA;
  constructor(public payload: any) {}
}
export class GetRangedRequestsDataSuccess implements Action {
  readonly type = DashboardActionTypes.GET_RANGED_REQUEST_DATA_SUCCESS;
  constructor(public payload: any) {}
}
export class GetRangedRequestsDataFailure implements Action {
  readonly type = DashboardActionTypes.GET_RANGED_REQUEST_DATA_FAILURE;
  constructor(public payload: any) {}
}
export class GetRangedVisitorData implements Action {
  readonly type = DashboardActionTypes.GET_RANGED_VISITOR_DATA;
  constructor(public payload: any) {}
}
export class GetRangedVisitorDataSuccess implements Action {
  readonly type = DashboardActionTypes.GET_RANGED_VISITOR_DATA_SUCCESS;
  constructor(public payload: any) {}
}
export class GetRangedVisitorDataFailure implements Action {
  readonly type = DashboardActionTypes.GET_RANGED_VISITOR_DATA_FAILURE;
  constructor(public payload: any) {}
}
export class GetRangedIncidentData implements Action {
  readonly type = DashboardActionTypes.GET_RANGED_INCIDENT_DATA;
  constructor(public payload: any) {}
}
export class GetRangedIncidentDataSuccess implements Action {
  readonly type = DashboardActionTypes.GET_RANGED_INCIDENT_DATA_SUCCESS;
  constructor(public payload: any) {}
}
export class GetRangedIncidentDataFailure implements Action {
  readonly type = DashboardActionTypes.GET_RANGED_INCIDENT_DATA_FAILURE;
  constructor(public payload: any) {}
}
export class GetDashboardData implements Action {
  readonly type = DashboardActionTypes.GET_DASHBOARD_DATA;
  constructor(public payload: any) {}
}
export class GetDashboardDataSuccess implements Action {
  readonly type = DashboardActionTypes.GET_DASHBOARD_DATA_SUCCESS;
  constructor(public payload: any) {}
}
export class GetDashboardDataFailure implements Action {
  readonly type = DashboardActionTypes.GET_DASHBOARD_DATA_FAILURE;
  constructor(public payload: any) {}
}
export class GetVisitorTabData implements Action {
  readonly type = DashboardActionTypes.GET_VISITOR_TAB_DATA;
  constructor(public payload: any) {}
}
export class GetVisitorTabDataSuccess implements Action {
  readonly type = DashboardActionTypes.GET_VISITOR_TAB_DATA_SUCCESS;
  constructor(public payload: any) {}
}
export class GetVisitorTabDataFailure implements Action {
  readonly type = DashboardActionTypes.GET_VISITOR_TAB_DATA_FAILURE;
  constructor(public payload: any) {}
}
export class GetIncidentTabData implements Action {
  readonly type = DashboardActionTypes.GET_INCIDENT_TAB_DATA;
  constructor(public payload: any) {}
}
export class GetIncidentTabDataSuccess implements Action {
  readonly type = DashboardActionTypes.GET_INCIDENT_TAB_DATA_SUCCESS;
  constructor(public payload: any) {}
}
export class GetIncidentTabDataFailure implements Action {
  readonly type = DashboardActionTypes.GET_INCIDENT_TAB_DATA_FAILURE;
  constructor(public payload: any) {}
}
export class UserLogout implements Action {
  readonly type = DashboardActionTypes.USER_LOGOUT;
  constructor(public payload: any) {}
}
export class RedirectingToLogin implements Action {
  readonly type = DashboardActionTypes.REDIRECTING_TO_LOGIN;
  constructor(public payload: any) {}
}

export class CheckExistingVisitor implements Action {
  readonly type = DashboardActionTypes.CHECK_EXISTING_VISITOR;
  constructor(public payload: any) {}
}
export class CheckExistingVisitorSuccess implements Action {
  readonly type = DashboardActionTypes.CHECK_EXISTING_VISITOR_SUCCESS;
  constructor(public payload: any) {}
}
export class CheckExistingVisitorFailure implements Action {
  readonly type = DashboardActionTypes.CHECK_EXISTING_VISITOR_FAILURE;
  constructor(public payload: any) {}
}

export class VisitorNotifyHost implements Action {
  readonly type = DashboardActionTypes.VISITOR_NOTIFY_HOST;
  constructor(public payload: any) {}
}
export class VisitorNotifyHostSuccess implements Action {
  readonly type = DashboardActionTypes.VISITOR_NOTIFY_HOST_SUCCESS;
  constructor(public payload: any) {}
}
export class VisitorNotifyHostFailure implements Action {
  readonly type = DashboardActionTypes.VISITOR_NOTIFY_HOST_FAILURE;
  constructor(public payload: any) {}
}
export class HostStatus implements Action {
  readonly type = DashboardActionTypes.HOST_STATUS;
  constructor(public payload: any) {}
}
export class HostStatusSuccess implements Action {
  readonly type = DashboardActionTypes.HOST_STATUS_SUCCESS;
  constructor(public payload: any) {}
}
export class HostStatusFailure implements Action {
  readonly type = DashboardActionTypes.HOST_STATUS_FAILURE;
  constructor(public payload: any) {}
}
export class ClearVisitorEntry implements Action {
  readonly type = DashboardActionTypes.CLEAR_VISITOR_ENTRY;
  constructor(public payload: any) {}
}
export class ClearVisitorEntrySuccess implements Action {
  readonly type = DashboardActionTypes.CLEAR_VISITOR_ENTRY_SUCCESS;
  constructor(public payload: any) {}
}
export class ClearVisitorEntryFailure implements Action {
  readonly type = DashboardActionTypes.CLEAR_VISITOR_ENTRY_FAILURE;
  constructor(public payload: any) {}
}
export class CreateManualIncident implements Action {
  readonly type = DashboardActionTypes.CREATE_MANUAL_INCIDENT;
  constructor(public payload: any) {}
}
export class CreateManualIncidentSuccess implements Action {
  readonly type = DashboardActionTypes.CREATE_MANUAL_INCIDENT_SUCCESS;
  constructor(public payload: any) {}
}
export class CreateManualIncidentFailure implements Action {
  readonly type = DashboardActionTypes.CREATE_MANUAL_INCIDENT_FAILURE;
  constructor(public payload: any) {}
}
export class VerifyIncident implements Action {
  readonly type = DashboardActionTypes.VERIFY_INCIDENT;
  constructor(public payload: any) {}
}
export class VerifyIncidentSuccess implements Action {
  readonly type = DashboardActionTypes.VERIFY_INCIDENT_SUCCESS;
  constructor(public payload: any) {}
}
export class VerifyIncidentFailure implements Action {
  readonly type = DashboardActionTypes.VERIFY_INCIDENT_FAILURE;
  constructor(public payload: any) {}
}
export class SnoozeIncident implements Action {
  readonly type = DashboardActionTypes.SNOOZE_INCIDENT;
  constructor(public payload: any) {}
}
export class SnoozeIncidentSuccess implements Action {
  readonly type = DashboardActionTypes.SNOOZE_INCIDENT_SUCCESS;
  constructor(public payload: any) {}
}
export class SnoozeIncidentFailure implements Action {
  readonly type = DashboardActionTypes.SNOOZE_INCIDENT_FAILURE;
  constructor(public payload: any) {}
}
export class InitUserProfile implements Action {
  readonly type = DashboardActionTypes.INIT_USER_PROFILE_SETTING;
  constructor(public payload: any) {}
}
export class InitPreVerified implements Action {
  readonly type = DashboardActionTypes.INIT_PRE_VERIFIED_TAB;
  constructor(public payload: any) {}
}
export class InitAumyeCommunity implements Action {
  readonly type = DashboardActionTypes.INIT_AUMYE_COMMUNITY;
  constructor(public payload: any) {}
}

export class UpdateVisitorList implements Action {
  readonly type = DashboardActionTypes.UPDATE_VISITOR_LIST;
  constructor(public payload: any) {}
}
export class UpdateVisitorListSuccess implements Action {
  readonly type = DashboardActionTypes.UPDATE_VISITOR_LIST_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateVisitorListFailure implements Action {
  readonly type = DashboardActionTypes.UPDATE_VISITOR_LIST_FAILURE;
  constructor(public payload: any) {}
}
export class UpdateIncidentList implements Action {
  readonly type = DashboardActionTypes.UPDATE_INCIDENT_LIST;
  constructor(public payload: any) {}
}
export class UpdateIncidentListSuccess implements Action {
  readonly type = DashboardActionTypes.UPDATE_INCIDENT_LIST_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateIncidentListFailure implements Action {
  readonly type = DashboardActionTypes.UPDATE_INCIDENT_LIST_FAILURE;
  constructor(public payload: any) {}
}
export class GetNumberPlatesList implements Action {
  readonly type = DashboardActionTypes.GET_NUMBER_PLATES_LIST;
  constructor(public payload: any) {}
}
export class GetNumberPlatesListSuccess implements Action {
  readonly type = DashboardActionTypes.GET_NUMBER_PLATES_LIST_SUCCESS;
  constructor(public payload: any) {}
}
export class GetNumberPlatesListFailure implements Action {
  readonly type = DashboardActionTypes.GET_NUMBER_PLATES_LIST_FAILURE;
  constructor(public payload: any) {}
}
export class GetFaceTimeline implements Action {
  readonly type = DashboardActionTypes.GET_FACE_TIMELINE;
  constructor(public payload: any) {}
}
export class GetFaceTimelineSuccess implements Action {
  readonly type = DashboardActionTypes.GET_FACE_TIMELINE_SUCCESS;
  constructor(public payload: any) {}
}
export class GetFaceTimelineFailure implements Action {
  readonly type = DashboardActionTypes.GET_FACE_TIMELINE_FAILURE;
  constructor(public payload: any) {}
}
export class GetIncidentEvidence implements Action {
  readonly type = DashboardActionTypes.GET_INCIDENT_EVIDENCE;
  constructor(public payload: any) {}
}
export class GetIncidentEvidenceSuccess implements Action {
  readonly type = DashboardActionTypes.GET_INCIDENT_EVIDENCE_SUCCESS;
  constructor(public payload: any) {}
}
export class GetIncidentEvidenceFailure implements Action {
  readonly type = DashboardActionTypes.GET_INCIDENT_EVIDENCE_FAILURE;
  constructor(public payload: any) {}
}
export class LodgeUserComplain implements Action {
  readonly type = DashboardActionTypes.LODGE_USER_COMPLAINT;
  constructor(public payload: any) {}
}
export class LodgeUserComplainSuccess implements Action {
  readonly type = DashboardActionTypes.LODGE_USER_COMPLAINT_SUCCESS;
  constructor(public payload: any) {}
}
export class LodgeUserComplainFailure implements Action {
  readonly type = DashboardActionTypes.LODGE_USER_COMPLAINT_FAILURE;
  constructor(public payload: any) {}
}
export class SendBulkInvite implements Action {
  readonly type = DashboardActionTypes.SEND_BULK_INVITE;
  constructor(public payload: any) {}
}
export class SendBulkInviteSuccess implements Action {
  readonly type = DashboardActionTypes.SEND_BULK_INVITE_SUCCESS;
  constructor(public payload: any) {}
}
export class SendBulkInviteFailure implements Action {
  readonly type = DashboardActionTypes.SEND_BULK_INVITE_FAILURE;
  constructor(public payload: any) {}
}
export class CreateNoticeBoardPost implements Action {
  readonly type = DashboardActionTypes.CREATE_NOTICE_BOARD_POST;
  constructor(public payload: any) {}
}
export class CreateNoticeBoardPostSuccess implements Action {
  readonly type = DashboardActionTypes.CREATE_NOTICE_BOARD_POST_SUCCESS;
  constructor(public payload: any) {}
}
export class CreateNoticeBoardPostFailure implements Action {
  readonly type = DashboardActionTypes.CREATE_NOTICE_BOARD_POST_FAILURE;
  constructor(public payload: any) {}
}
export class GetNoticeBoardPosts implements Action {
  readonly type = DashboardActionTypes.GET_NOTICE_BOARD_POSTS;
  constructor(public payload: any) {}
}
export class GetNoticeBoardPostsSuccess implements Action {
  readonly type = DashboardActionTypes.GET_NOTICE_BOARD_POSTS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetNoticeBoardPostsFailure implements Action {
  readonly type = DashboardActionTypes.GET_NOTICE_BOARD_POSTS_FAILURE;
  constructor(public payload: any) {}
}
export class PostUserComment implements Action {
  readonly type = DashboardActionTypes.POST_USER_COMMENT;
  constructor(public payload: any) {}
}
export class PostUserCommentSuccess implements Action {
  readonly type = DashboardActionTypes.POST_USER_COMMENT_SUCCESS;
  constructor(public payload: any) {}
}
export class PostUserCommentFailure implements Action {
  readonly type = DashboardActionTypes.POST_USER_COMMENT_FAILURE;
  constructor(public payload: any) {}
}
export class ReportCommunityPost implements Action {
  readonly type = DashboardActionTypes.REPORT_POST;
  constructor(public payload: any) {}
}
export class ReportCommunityPostSuccess implements Action {
  readonly type = DashboardActionTypes.REPORT_POST_SUCCESS;
  constructor(public payload: any) {}
}
export class ReportCommunityPostFailure implements Action {
  readonly type = DashboardActionTypes.REPORT_POST_FAILURE;
  constructor(public payload: any) {}
}
export class AcceptOrRejectPost implements Action {
  readonly type = DashboardActionTypes.ACCEPT_OR_REJECT_POST;
  constructor(public payload: any) {}
}
export class AcceptOrRejectPostSuccess implements Action {
  readonly type = DashboardActionTypes.ACCEPT_OR_REJECT_POST_SUCCESS;
  constructor(public payload: any) {}
}
export class AcceptOrRejectPostFailure implements Action {
  readonly type = DashboardActionTypes.ACCEPT_OR_REJECT_POST_FAILURE;
  constructor(public payload: any) {}
}
export class DeleteUserPermanently implements Action {
  readonly type = DashboardActionTypes.DELETE_USER_PERMANENTLY;
  constructor(public payload: any) {}
}
export class DeleteUserPermanentlySuccess implements Action {
  readonly type = DashboardActionTypes.DELETE_USER_PERMANENTLY_SUCCESS;
  constructor(public payload: any) {}
}
export class DeleteUserPermanentlyFailure implements Action {
  readonly type = DashboardActionTypes.DELETE_USER_PERMANENTLY_FAILURE;
  constructor(public payload: any) {}
}
export class UpdateFlaggedPost implements Action {
  readonly type = DashboardActionTypes.UPDATE_FLAGGED_POST;
  constructor(public payload: any) {}
}
export class UpdateFlaggedPostSuccess implements Action {
  readonly type = DashboardActionTypes.UPDATE_FLAGGED_POST_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateFlaggedPostFailure implements Action {
  readonly type = DashboardActionTypes.UPDATE_FLAGGED_POST_FAILURE;
  constructor(public payload: any) {}
}

export class PostUserLike implements Action {
  readonly type = DashboardActionTypes.POST_USER_LIKE;
  constructor(public payload: any) {}
}
export class PostUserLikeSuccess implements Action {
  readonly type = DashboardActionTypes.POST_USER_LIKE_SUCCESS;
  constructor(public payload: any) {}
}
export class PostUserLikeFailure implements Action {
  readonly type = DashboardActionTypes.POST_USER_LIKE_FAILURE;
  constructor(public payload: any) {}
}
export class AddPreApprovedVisitor implements Action {
  readonly type = DashboardActionTypes.ADD_PRE_APPROVED_VISITOR;
  constructor(public payload: any) {}
}
export class AddPreApprovedVisitorSuccess implements Action {
  readonly type = DashboardActionTypes.ADD_PRE_APPROVED_VISITOR_SUCCESS;
  constructor(public payload: any) {}
}
export class AddPreApprovedVisitorFailure implements Action {
  readonly type = DashboardActionTypes.ADD_PRE_APPROVED_VISITOR_FAILURE;
  constructor(public payload: any) {}
}
export class RapidScheduleVisitor implements Action {
  readonly type = DashboardActionTypes.RAPID_SCHEDULE_VISITOR;
  constructor(public payload: any) {}
}
export class RapidScheduleVisitorSuccess implements Action {
  readonly type = DashboardActionTypes.RAPID_SCHEDULE_VISITOR_SUCCESS;
  constructor(public payload: any) {}
}
export class RapidScheduleVisitorFailure implements Action {
  readonly type = DashboardActionTypes.RAPID_SCHEDULE_VISITOR_FAILURE;
  constructor(public payload: any) {}
}
export class GetUserEventsList implements Action {
  readonly type = DashboardActionTypes.GET_USER_EVENTS_LIST;
  constructor(public payload: any) {}
}
export class GetUserEventsListSuccess implements Action {
  readonly type = DashboardActionTypes.GET_USER_EVENTS_LIST_SUCCESS;
  constructor(public payload: any) {}
}
export class GetUserEventsListFailure implements Action {
  readonly type = DashboardActionTypes.GET_USER_EVENTS_LIST_FAILURE;
  constructor(public payload: any) {}
}
export class CreateUserPoll implements Action {
  readonly type = DashboardActionTypes.CREATE_USER_POLL;
  constructor(public payload: any) {}
}
export class CreateUserPollSuccess implements Action {
  readonly type = DashboardActionTypes.CREATE_USER_POLL_SUCCESS;
  constructor(public payload: any) {}
}
export class CreateUserPollFailure implements Action {
  readonly type = DashboardActionTypes.CREATE_USER_POLL_FAILURE;
  constructor(public payload: any) {}
}
export class ManageUserPolls implements Action {
  readonly type = DashboardActionTypes.MANAGE_USER_POLL;
  constructor(public payload: any) {}
}
export class ManageUserPollsSuccess implements Action {
  readonly type = DashboardActionTypes.MANAGE_USER_POLL_SUCCESS;
  constructor(public payload: any) {}
}
export class ManageUserPollsFailure implements Action {
  readonly type = DashboardActionTypes.MANAGE_USER_POLL_FAILURE;
  constructor(public payload: any) {}
}
export class GetUserPolls implements Action {
  readonly type = DashboardActionTypes.GET_USER_POLL_LIST;
  constructor(public payload: any) {}
}
export class GetUserPollsSuccess implements Action {
  readonly type = DashboardActionTypes.GET_USER_POLL_LIST_SUCCESS;
  constructor(public payload: any) {}
}
export class GetUserPollsFailure implements Action {
  readonly type = DashboardActionTypes.GET_USER_POLL_LIST_FAILURE;
  constructor(public payload: any) {}
}
export class SubmitPollResponse implements Action {
  readonly type = DashboardActionTypes.SUBMIT_POLL_RESPONSE;
  constructor(public payload: any) {}
}
export class SubmitPollResponseSuccess implements Action {
  readonly type = DashboardActionTypes.SUBMIT_POLL_RESPONSE_SUCCESS;
  constructor(public payload: any) {}
}
export class SubmitPollResponseFailure implements Action {
  readonly type = DashboardActionTypes.SUBMIT_POLL_RESPONSE_FAILURE;
  constructor(public payload: any) {}
}
export class UpdateVisitorDetails implements Action {
  readonly type = DashboardActionTypes.UPDATE_VISITOR_DETAILS;
  constructor(public payload: any) {}
}
export class UpdateVisitorDetailsSuccess implements Action {
  readonly type = DashboardActionTypes.UPDATE_VISITOR_DETAILS_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateVisitorDetailsFailure implements Action {
  readonly type = DashboardActionTypes.UPDATE_VISITOR_DETAILS_FAILURE;
  constructor(public payload: any) {}
}
export class PreApprovedVisitorCheckout implements Action {
  readonly type = DashboardActionTypes.PRE_APPROVED_VISITOR_CHECKOUT;
  constructor(public payload: any) {}
}
export class PreApprovedVisitorCheckoutSuccess implements Action {
  readonly type = DashboardActionTypes.PRE_APPROVED_VISITOR_CHECKOUT_SUCCESS;
  constructor(public payload: any) {}
}
export class PreApprovedVisitorCheckoutFailure implements Action {
  readonly type = DashboardActionTypes.PRE_APPROVED_VISITOR_CHECKOUT_FAILURE;
  constructor(public payload: any) {}
}
export class UpdateVisitorIdDetail implements Action {
  readonly type = DashboardActionTypes.UPDATE_VISITOR_ID_DETAIL;
  constructor(public payload: any) {}
}
export class UpdateVisitorIdDetailSuccess implements Action {
  readonly type = DashboardActionTypes.UPDATE_VISITOR_ID_DETAIL_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateVisitorIdDetailFailure implements Action {
  readonly type = DashboardActionTypes.UPDATE_VISITOR_ID_DETAIL_FAILURE;
  constructor(public payload: any) {}
}
export class RequestSOS implements Action {
  readonly type = DashboardActionTypes.REQUEST_SOS;
  constructor(public payload: any) {}
}
export class RequestSOSSuccess implements Action {
  readonly type = DashboardActionTypes.REQUEST_SOS_SUCCESS;
  constructor(public payload: any) {}
}
export class RequestSOSFailed implements Action {
  readonly type = DashboardActionTypes.REQUEST_SOS_FAILED;
  constructor(public payload: any) {}
}
export class RespondSOS implements Action {
  readonly type = DashboardActionTypes.RESPOND_SOS;
  constructor(public payload: any) {}
}
export class StoreUserLocation implements Action {
  readonly type = DashboardActionTypes.STORE_LOCATION;
  constructor(public payload: any) {}
}

export class SendReportsData implements Action {
  readonly type = DashboardActionTypes.SEND_REPORTS_DATA;
  constructor(public payload: any) {}
}
export class SendReportsDataSuccess implements Action {
  readonly type = DashboardActionTypes.SEND_REPORTS_DATA_SUCCESS;
  constructor(public payload: any) {}
}
export class SendReportsDataFailure implements Action {
  readonly type = DashboardActionTypes.SEND_REPORTS_DATA_FAILURE;
  constructor(public payload: any) {}
}
export class UpdateAssetsData implements Action {
  readonly type = DashboardActionTypes.UPDATE_ASSETS_DATA;
  constructor(public payload: any) {}
}
export class FetchEmployees implements Action {
  readonly type = DashboardActionTypes.FETCH_EMPLOYEES;
  constructor(public payload: any) {}
}
export class FetchEmployeesSuccess implements Action {
  readonly type = DashboardActionTypes.FETCH_EMPLOYEES_SUCCESS;
  constructor(public payload: any) {}
}
export class FetchEmployeesFailure implements Action {
  readonly type = DashboardActionTypes.FETCH_EMPLOYEES_FAILURE;
  constructor(public payload: any) {}
}
export class UpdateEmployees implements Action {
  readonly type = DashboardActionTypes.UPDATE_EMPLOYEES;
  constructor(public payload: any) {}
}
export class UpdateEmployeesSuccess implements Action {
  readonly type = DashboardActionTypes.UPDATE_EMPLOYEES_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateEmployeesFailure implements Action {
  readonly type = DashboardActionTypes.UPDATE_EMPLOYEES_FAILURE;
  constructor(public payload: any) {}
}
export class LogEmployeeAttendance implements Action {
  readonly type = DashboardActionTypes.LOG_EMPLOYEE_ATTENDANCE;
  constructor(public payload: any) {}
}
export class LogEmployeeAttendanceSuccess implements Action {
  readonly type = DashboardActionTypes.LOG_EMPLOYEE_ATTENDANCE_SUCCESS;
  constructor(public payload: any) {}
}
export class LogEmployeeAttendanceFailure implements Action {
  readonly type = DashboardActionTypes.LOG_EMPLOYEE_ATTENDANCE_FAILURE;
  constructor(public payload: any) {}
}
export class SendQrWhatsapp implements Action {
  readonly type = DashboardActionTypes.SEND_QR_WHATSAPP;
  constructor(public payload: any) {}
}
export class SendQrWhatsappSuccess implements Action {
  readonly type = DashboardActionTypes.SEND_QR_WHATSAPP_SUCCESS;
  constructor(public payload: any) {}
}
export class SendQrWhatsappFailure implements Action {
  readonly type = DashboardActionTypes.SEND_QR_WHATSAPP_FAILURE;
  constructor(public payload: any) {}
}

export class SearchNumber implements Action {
  readonly type = DashboardActionTypes.SEARCH_NUMBER;
  constructor(public payload: any) {}
}
export class SearchNumberSuccess implements Action {
  readonly type = DashboardActionTypes.SEARCH_NUMBER_SUCCESS;
  constructor(public payload: any) {}
}
export class SearchNumberFailure implements Action {
  readonly type = DashboardActionTypes.SEARCH_NUMBER_FAILURE;
  constructor(public payload: any) {}
}
export class SaveOrgSettings implements Action {
  readonly type = DashboardActionTypes.SAVE_ORG_SETTINGS;
  constructor(public payload: any) {}
}
export class SaveOrgSettingsSuccess implements Action {
  readonly type = DashboardActionTypes.SAVE_ORG_SETTINGS_SUCCESS;
  constructor(public payload: any) {}
}
export class SaveOrgSettingsFailure implements Action {
  readonly type = DashboardActionTypes.SAVE_ORG_SETTINGS_FAILURE;
  constructor(public payload: any) {}
}

export class GetOrgSettings implements Action {
  readonly type = DashboardActionTypes.GET_ORG_SETTINGS;
  constructor(public payload: any) {}
}
export class GetOrgSettingsSuccess implements Action {
  readonly type = DashboardActionTypes.GET_ORG_SETTINGS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetOrgSettingsFailure implements Action {
  readonly type = DashboardActionTypes.GET_ORG_SETTINGS_FAILURE;
  constructor(public payload: any) {}
}

export class ManageVisitorPass implements Action {
  readonly type = DashboardActionTypes.MANAGE_VISITOR_PASS;
  constructor(public payload: any) {}
}
export class ManageVisitorPassSuccess implements Action {
  readonly type = DashboardActionTypes.MANAGE_VISITOR_PASS_SUCCESS;
  constructor(public payload: any) {}
}
export class ManageVisitorPassFailure implements Action {
  readonly type = DashboardActionTypes.MANAGE_VISITOR_PASS_FAILURE;
  constructor(public payload: any) {}
}

export class SaveUserInventory implements Action {
  readonly type = DashboardActionTypes.SAVE_USER_INVENTORY;
  constructor(public payload: any) {}
}
export class SaveUserInventorySuccess implements Action {
  readonly type = DashboardActionTypes.SAVE_USER_INVENTORY_SUCCESS;
  constructor(public payload: any) {}
}
export class SaveUserInventoryFailure implements Action {
  readonly type = DashboardActionTypes.SAVE_USER_INVENTORY_FAILURE;
  constructor(public payload: any) {}
}

export class GetUserInventory implements Action {
  readonly type = DashboardActionTypes.GET_USER_INVENTORY;
  constructor(public payload: any) {}
}
export class GetUserInventorySuccess implements Action {
  readonly type = DashboardActionTypes.GET_USER_INVENTORY_SUCCESS;
  constructor(public payload: any) {}
}
export class GetUserInventoryFailure implements Action {
  readonly type = DashboardActionTypes.GET_USER_INVENTORY_FAILURE;
  constructor(public payload: any) {}
}
export class AddUsersToEmployees implements Action {
  readonly type = DashboardActionTypes.ADD_USER_EMPLOYEES;
  constructor(public payload: any) {}
}
export class AddUsersToEmployeesSuccess implements Action {
  readonly type = DashboardActionTypes.ADD_USER_EMPLOYEES_SUCCESS;
  constructor(public payload: any) {}
}
export class AddUsersToEmployeesFailure implements Action {
  readonly type = DashboardActionTypes.ADD_USER_EMPLOYEES_FAILURE;
  constructor(public payload: any) {}
}
// Complaint Actions
export class AddNewComplaint implements Action {
  readonly type = DashboardActionTypes.ADD_NEW_COMPLAINT;
  constructor(public payload: any) {}
}
export class AddNewComplaintSuccess implements Action {
  readonly type = DashboardActionTypes.ADD_NEW_COMPLAINT_SUCCESS;
  constructor(public payload: any) {}
}
export class AddNewComplaintFailure implements Action {
  readonly type = DashboardActionTypes.ADD_NEW_COMPLAINT_FAILURE;
  constructor(public error: any) {}
}

export class UpdateComplaintById implements Action {
  readonly type = DashboardActionTypes.UPDATE_COMPLAINT_BY_ID;
  constructor(public payload: any) {}
}
export class UpdateComplaintByIdSuccess implements Action {
  readonly type = DashboardActionTypes.UPDATE_COMPLAINT_BY_ID_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateComplaintByIdFailure implements Action {
  readonly type = DashboardActionTypes.UPDATE_COMPLAINT_BY_ID_FAILURE;
  constructor(public error: any) {}
}

// Claim Actions
export class AddNewClaim implements Action {
  readonly type = DashboardActionTypes.ADD_NEW_CLAIM;
  constructor(public payload: any) {}
}
export class AddNewClaimSuccess implements Action {
  readonly type = DashboardActionTypes.ADD_NEW_CLAIM_SUCCESS;
  constructor(public payload: any) {}
}
export class AddNewClaimFailure implements Action {
  readonly type = DashboardActionTypes.ADD_NEW_CLAIM_FAILURE;
  constructor(public error: any) {}
}

export class UpdateClaimById implements Action {
  readonly type = DashboardActionTypes.UPDATE_CLAIM_BY_ID;
  constructor(public payload: any) {}
}
export class UpdateClaimByIdSuccess implements Action {
  readonly type = DashboardActionTypes.UPDATE_CLAIM_BY_ID_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateClaimByIdFailure implements Action {
  readonly type = DashboardActionTypes.UPDATE_CLAIM_BY_ID_FAILURE;
  constructor(public error: any) {}
}

// Request Actions
export class AddNewRequest implements Action {
  readonly type = DashboardActionTypes.ADD_NEW_REQUEST;
  constructor(public payload: any) {}
}
export class AddNewRequestSuccess implements Action {
  readonly type = DashboardActionTypes.ADD_NEW_REQUEST_SUCCESS;
  constructor(public payload: any) {}
}
export class AddNewRequestFailure implements Action {
  readonly type = DashboardActionTypes.ADD_NEW_REQUEST_FAILURE;
  constructor(public error: any) {}
}

export class UpdateRequestById implements Action {
  readonly type = DashboardActionTypes.UPDATE_REQUEST_BY_ID;
  constructor(public payload: any) {}
}
export class UpdateRequestByIdSuccess implements Action {
  readonly type = DashboardActionTypes.UPDATE_REQUEST_BY_ID_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateRequestByIdFailure implements Action {
  readonly type = DashboardActionTypes.UPDATE_REQUEST_BY_ID_FAILURE;
  constructor(public error: any) {}
}

// Incident Actions
export class AddNewIncident implements Action {
  readonly type = DashboardActionTypes.ADD_NEW_INCIDENT;
  constructor(public payload: any) {}
}
export class AddNewIncidentSuccess implements Action {
  readonly type = DashboardActionTypes.ADD_NEW_INCIDENT_SUCCESS;
  constructor(public payload: any) {}
}
export class AddNewIncidentFailure implements Action {
  readonly type = DashboardActionTypes.ADD_NEW_INCIDENT_FAILURE;
  constructor(public error: any) {}
}

export class UpdateIncidentById implements Action {
  readonly type = DashboardActionTypes.UPDATE_INCIDENT_BY_ID;
  constructor(public payload: any) {}
}
export class UpdateIncidentByIdSuccess implements Action {
  readonly type = DashboardActionTypes.UPDATE_INCIDENT_BY_ID_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateIncidentByIdFailure implements Action {
  readonly type = DashboardActionTypes.UPDATE_INCIDENT_BY_ID_FAILURE;
  constructor(public error: any) {}
}

// Visitor Actions
export class AddNewVisitor implements Action {
  readonly type = DashboardActionTypes.ADD_NEW_VISITOR;
  constructor(public payload: any) {}
}
export class AddNewVisitorSuccess implements Action {
  readonly type = DashboardActionTypes.ADD_NEW_VISITOR_SUCCESS;
  constructor(public payload: any) {}
}
export class AddNewVisitorFailure implements Action {
  readonly type = DashboardActionTypes.ADD_NEW_VISITOR_FAILURE;
  constructor(public error: any) {}
}
export class UpdateVisitorById implements Action {
  readonly type = DashboardActionTypes.UPDATE_VISITOR_BY_ID;
  constructor(public payload: any) {}
}
export class UpdateVisitorByIdSuccess implements Action {
  readonly type = DashboardActionTypes.UPDATE_VISITOR_BY_ID_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateVisitorByIdFailure implements Action {
  readonly type = DashboardActionTypes.UPDATE_VISITOR_BY_ID_FAILURE;
  constructor(public error: any) {}
}

// Users Actions
export class AddNewUser implements Action {
  readonly type = DashboardActionTypes.ADD_NEW_USER;
  constructor(public payload: any) {}
}
export class AddNewUserSuccess implements Action {
  readonly type = DashboardActionTypes.ADD_NEW_USER_SUCCESS;
  constructor(public payload: any) {}
}
export class AddNewUserFailure implements Action {
  readonly type = DashboardActionTypes.ADD_NEW_USER_FAILURE;
  constructor(public error: any) {}
}
export class UpdateUserById implements Action {
  readonly type = DashboardActionTypes.UPDATE_USER_BY_ID;
  constructor(public payload: any) {}
}
export class UpdateUserByIdSuccess implements Action {
  readonly type = DashboardActionTypes.UPDATE_USER_BY_ID_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateUserByIdFailure implements Action {
  readonly type = DashboardActionTypes.UPDATE_USER_BY_ID_FAILURE;
  constructor(public error: any) {}
}

export class RemoveIncidentById implements Action {
  readonly type = DashboardActionTypes.REMOVE_INCIDENT_BY_ID;
  constructor(public payload: any) {}
}
export class RemoveIncidentByIdSuccess implements Action {
  readonly type = DashboardActionTypes.REMOVE_INCIDENT_BY_ID_SUCCESS;
  constructor(public payload: any) {}
}
export class RemoveIncidentByIdFailure implements Action {
  readonly type = DashboardActionTypes.REMOVE_INCIDENT_BY_ID_FAILURE;
  constructor(public error: any) {}
}

export class RemoveClaimsById implements Action {
  readonly type = DashboardActionTypes.REMOVE_CLAIMS_BY_ID;
  constructor(public payload: any) {}
}
export class RemoveClaimsByIdSuccess implements Action {
  readonly type = DashboardActionTypes.REMOVE_CLAIMS_BY_ID_SUCCESS;
  constructor(public payload: any) {}
}
export class RemoveClaimsByIdFailure implements Action {
  readonly type = DashboardActionTypes.REMOVE_CLAIMS_BY_ID_FAILURE;
  constructor(public error: any) {}
}

export class RemoveServiceById implements Action {
  readonly type = DashboardActionTypes.REMOVE_SERVICE_BY_ID;
  constructor(public payload: any) {}
}
export class RemoveServiceByIdSuccess implements Action {
  readonly type = DashboardActionTypes.REMOVE_SERVICE_BY_ID_SUCCESS;
  constructor(public payload: any) {}
}
export class RemoveServiceByIdFailure implements Action {
  readonly type = DashboardActionTypes.REMOVE_SERVICE_BY_ID_FAILURE;
  constructor(public error: any) {}
}

export class RemoveComplaintsById implements Action {
  readonly type = DashboardActionTypes.REMOVE_COMPLAINTS_BY_ID;
  constructor(public payload: any) {}
}
export class RemoveComplaintsByIdSuccess implements Action {
  readonly type = DashboardActionTypes.REMOVE_COMPLAINTS_BY_ID_SUCCESS;
  constructor(public payload: any) {}
}
export class RemoveComplaintsByIdFailure implements Action {
  readonly type = DashboardActionTypes.REMOVE_COMPLAINTS_BY_ID_FAILURE;
  constructor(public error: any) {}
}

export class AddNewNotification implements Action {
  readonly type = DashboardActionTypes.ADD_NEW_NOTIFICATION;
  constructor(public payload: any) {}
}
export class MarkReadNotification implements Action {
  readonly type = DashboardActionTypes.MARK_READ_NOTIFICATION;
  constructor(public payload: any) {}
}
export class GetSavedNotification implements Action {
  readonly type = DashboardActionTypes.GET_SAVED_NOTIFICATION;
  constructor(public error: any) {}
}

//Employee Actions
export class UpdateEmployeeAttendanceById implements Action {
  readonly type = DashboardActionTypes.UPDATE_EMPLOYEE_ATTENDANCE_BY_ID;
  constructor(public payload: any) {}
}
export class UpdateEmployeeAttendanceByIdSuccess implements Action {
  readonly type = DashboardActionTypes.UPDATE_EMPLOYEE_ATTENDANCE_BY_ID_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateEmployeeAttendanceByIdFailure implements Action {
  readonly type = DashboardActionTypes.UPDATE_EMPLOYEE_ATTENDANCE_BY_ID_FAILURE;
  constructor(public error: any) {}
}

export type CyclopsDashboardActionUnion =
  | ResetState
  | InitEmplopyee
  | InitDashboard
  | InitDashboardSim
  | InitAssetsTab
  | InitAnalyticsTab
  | InitCalendarTab
  | InitMediaWallTab
  | InitManageUserTab
  | InitSettingsTab
  | InitSecurityGuardTab
  | InitVisitorGateEntry
  | InitIncidentManualEvent
  | SetContextData
  | GetIncidentTabData
  | GetIncidentTabDataSuccess
  | GetIncidentTabDataFailure
  | GetVisitorTabData
  | GetVisitorTabDataSuccess
  | GetVisitorTabDataFailure
  | UserLogout
  | RedirectingToLogin
  | CheckExistingVisitor
  | CheckExistingVisitorSuccess
  | CheckExistingVisitorFailure
  | GetUserList
  | GetUserListSuccess
  | GetUserListFailure
  | VisitorNotifyHost
  | VisitorNotifyHostSuccess
  | VisitorNotifyHostFailure
  | HostStatus
  | HostStatusSuccess
  | HostStatusFailure
  | ClearVisitorEntry
  | ClearVisitorEntrySuccess
  | ClearVisitorEntryFailure
  | CreateManualIncident
  | CreateManualIncidentSuccess
  | CreateManualIncidentFailure
  | LoadAllAssets
  | LoadAllAssetsSuccess
  | LoadAllAssetsFailure
  | GetRangedIncidentData
  | GetRangedIncidentDataSuccess
  | GetRangedIncidentDataFailure
  | GetRangedVisitorData
  | GetRangedVisitorDataSuccess
  | GetRangedVisitorDataFailure
  | GetRangedRequestsData
  | GetRangedRequestsDataSuccess
  | GetRangedRequestsDataFailure
  | SnoozeIncident
  | SnoozeIncidentSuccess
  | SnoozeIncidentFailure
  | VerifyIncident
  | VerifyIncidentSuccess
  | VerifyIncidentFailure
  | InitReportsTab
  | InitUserProfile
  | InitPreVerified
  | InitAumyeCommunity
  | UpdateVisitorList
  | UpdateVisitorListSuccess
  | UpdateVisitorListFailure
  | UpdateIncidentList
  | UpdateIncidentListSuccess
  | UpdateIncidentListFailure
  | GetNumberPlatesList
  | GetNumberPlatesListSuccess
  | GetNumberPlatesListFailure
  | GetFaceTimeline
  | GetFaceTimelineSuccess
  | GetFaceTimelineFailure
  | GetIncidentEvidence
  | GetIncidentEvidenceSuccess
  | GetIncidentEvidenceFailure
  | LodgeUserComplain
  | LodgeUserComplainSuccess
  | LodgeUserComplainFailure
  | SendBulkInvite
  | SendBulkInviteSuccess
  | SendBulkInviteFailure
  | CreateNoticeBoardPost
  | CreateNoticeBoardPostSuccess
  | CreateNoticeBoardPostFailure
  | GetNoticeBoardPosts
  | GetNoticeBoardPostsSuccess
  | GetNoticeBoardPostsFailure
  | PostUserComment
  | PostUserCommentSuccess
  | PostUserCommentFailure
  | ReportCommunityPost
  | ReportCommunityPostSuccess
  | ReportCommunityPostFailure
  | PostUserLike
  | PostUserLikeFailure
  | PostUserLikeSuccess
  | AddPreApprovedVisitor
  | AddPreApprovedVisitorSuccess
  | AddPreApprovedVisitorFailure
  | RapidScheduleVisitor
  | RapidScheduleVisitorSuccess
  | RapidScheduleVisitorFailure
  | GetUserEventsList
  | GetUserEventsListFailure
  | GetUserEventsListSuccess
  | CreateUserPoll
  | CreateUserPollFailure
  | CreateUserPollSuccess
  | GetUserPolls
  | GetUserPollsSuccess
  | GetUserPollsFailure
  | SubmitPollResponse
  | SubmitPollResponseSuccess
  | SubmitPollResponseFailure
  | UpdateVisitorDetails
  | UpdateVisitorDetailsSuccess
  | UpdateVisitorDetailsFailure
  | PreApprovedVisitorCheckout
  | PreApprovedVisitorCheckoutFailure
  | PreApprovedVisitorCheckoutSuccess
  | UpdateVisitorIdDetail
  | UpdateVisitorIdDetailFailure
  | UpdateVisitorIdDetailSuccess
  | InitSecurityAdvanced
  | RequestSOS
  | RequestSOSSuccess
  | RequestSOSFailed
  | RespondSOS
  | SendReportsData
  | SendReportsDataFailure
  | SendReportsDataSuccess
  | UpdateAssetsData
  | FetchEmployees
  | FetchEmployeesFailure
  | FetchEmployeesSuccess
  | UpdateEmployees
  | UpdateEmployeesFailure
  | UpdateEmployeesSuccess
  | LogEmployeeAttendance
  | LogEmployeeAttendanceSuccess
  | LogEmployeeAttendanceFailure
  | SendQrWhatsapp
  | SendQrWhatsappFailure
  | SendQrWhatsappSuccess
  | SearchNumber
  | SearchNumberSuccess
  | SearchNumberFailure
  | SaveOrgSettings
  | SaveOrgSettingsSuccess
  | SaveOrgSettingsFailure
  | GetOrgSettings
  | GetOrgSettingsSuccess
  | GetOrgSettingsFailure
  | ManageVisitorPass
  | ManageVisitorPassSuccess
  | ManageVisitorPassFailure
  | GetUserInventory
  | GetUserInventorySuccess
  | GetUserInventoryFailure
  | SaveUserInventory
  | SaveUserInventoryFailure
  | SaveUserInventorySuccess
  | ManageUserPolls
  | ManageUserPollsSuccess
  | ManageUserPollsFailure
  | GetComplaintsTickets
  | GetComplaintsTicketsSuccess
  | GetComplaintsTicketsFailure
  | ClusterPreApprovedVisitor
  | ClusterPreApprovedVisitorSuccess
  | ClusterPreApprovedVisitorFailure
  | SaveAppToken
  | SaveAppTokenSuccess
  | SaveAppTokenFailed
  | RemoveAppToken
  | RemoveAppTokenSuccess
  | RemoveAppTokenFailed
  | AddUsersToEmployees
  | AddUsersToEmployeesSuccess
  | AddUsersToEmployeesFailure
  | GetDashboardData
  | GetDashboardDataSuccess
  | GetDashboardDataFailure
  | SaveIncidentData
  | UpdateIncidentData
  | UpdateSOSData
  | SaveSOSData
  | SavePropertyData
  | SaveAssetData
  | SaveUserData
  | SaveComplainData
  | UpdateComplainData
  | SaveRiskData
  | GetClaimTickets
  | GetClaimTicketsSuccess
  | GetClaimTicketsFailed
  | GetRequestsTickets
  | GetRequestsTicketsSuccess
  | GetRequestsTicketsFailed
  | AddNewComplaint
  | AddNewComplaintSuccess
  | AddNewComplaintFailure
  | UpdateComplaintById
  | UpdateComplaintByIdSuccess
  | UpdateComplaintByIdFailure
  | AddNewClaim
  | AddNewClaimSuccess
  | AddNewClaimFailure
  | UpdateClaimById
  | UpdateClaimByIdSuccess
  | UpdateClaimByIdFailure
  | AddNewRequest
  | AddNewRequestSuccess
  | AddNewRequestFailure
  | UpdateRequestById
  | UpdateRequestByIdSuccess
  | UpdateRequestByIdFailure
  | AddNewIncident
  | AddNewIncidentSuccess
  | AddNewIncidentFailure
  | UpdateIncidentById
  | UpdateIncidentByIdSuccess
  | UpdateIncidentByIdFailure
  | AddNewVisitor
  | AddNewVisitorSuccess
  | AddNewVisitorFailure
  | UpdateVisitorById
  | UpdateVisitorByIdSuccess
  | UpdateVisitorByIdFailure
  | AddNewUser
  | AddNewUserSuccess
  | AddNewUserFailure
  | UpdateUserById
  | UpdateUserByIdSuccess
  | UpdateUserByIdFailure
  | UpdateEmployeeAttendanceById
  | UpdateEmployeeAttendanceByIdSuccess
  | UpdateEmployeeAttendanceByIdFailure
  | AddNewNotification
  | MarkReadNotification
  | GetSavedNotification
  | RemoveIncidentById
  | RemoveIncidentByIdSuccess
  | RemoveIncidentByIdFailure
  | RemoveClaimsById
  | RemoveClaimsByIdSuccess
  | RemoveClaimsByIdFailure
  | RemoveComplaintsById
  | RemoveComplaintsByIdSuccess
  | RemoveComplaintsByIdFailure
  | RemoveServiceById
  | RemoveServiceByIdSuccess
  | RemoveServiceByIdFailure
  | AcceptOrRejectPost
  | AcceptOrRejectPostSuccess
  | AcceptOrRejectPostFailure
  | DeleteUserPermanently
  | DeleteUserPermanentlySuccess
  | DeleteUserPermanentlyFailure
  | UpdateFlaggedPost
  | UpdateFlaggedPostSuccess
  | UpdateFlaggedPostFailure;
